const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

async function parseErrorMessage(res) {
  try {
    const data = await res.json();
    return data.detail || data.message || `Request failed (${res.status})`;
  } catch (e) {
    return `Request failed (${res.status})`;
  }
}

export async function submitFeatureRequest(message, email) {
  const res = await fetch(`${API}/feature-requests`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ message, email }),
  });
  if (!res.ok) throw new Error(await parseErrorMessage(res));
  return res.json();
}
